import {createReducer} from '@reduxjs/toolkit';
import bitgeo from 'bitgeo';
import {set, setByCoordinate, setByExtent} from '../actions/geometry.js';
import {modes, setMode} from '../actions/ui.js';
import geometryFromExtent from '../util/geometry-from-extent.js';

export const initialState = {
  json: null,
  bitbox: null,
};

export default createReducer(initialState, builder => {
  builder.addCase(set, (state, {payload: json}) => {
    state.json = json;
    state.bitbox = json ? bitgeo(json, {resolution: 0.005}) : null;
  });

  builder.addCase(setByCoordinate, (state, {payload: coordinates}) => {
    state.json = {
      type: 'Point',
      coordinates,
    };
    state.bitbox = null;
  });

  builder.addCase(setByExtent, (state, {payload: extent}) => {
    state.json = geometryFromExtent(extent);
    state.bitbox = null;
  });

  builder.addCase(setMode, (state, {payload: mode}) => {
    if (mode === modes.NONE || mode === modes.COMPARE) {
      return initialState;
    }
    return state;
  });
});
